@let _greetingsDTO = greetingsDTO();
<article nz-typography>
  <nz-row [nzGutter]="[16, 16]">
    <nz-col [nzSpan]="24">
      <p class="greetings-title" nz-typography>{{ _greetingsDTO.title }}</p>
    </nz-col>
    <nz-col [nzSpan]="24">
      <p nz-typography>{{ _greetingsDTO.paragraph }}</p>
    </nz-col>
  </nz-row>
</article>
